import moment from "moment/moment";

export const SET_LEAD_FILTER_PARAMS = 'SET_LEAD_FILTER_PARAMS';
export const SET_LOG_FILTER_PARAMS = 'SET_LEAD_FILTER_PARAMS';
export const SET_COLUMN_FILTER_PARAMS = 'SET_COLUMN_FILTER_PARAMS';
export const SET_TASK_LIST_FILTER_PARAMS = 'SET_TASK_LIST_FILTER_PARAMS';
export const SET_PROPOSAL_LIST_FILTER_PARAMS = 'SET_PROPOSAL_LIST_FILTER_PARAMS';
export const SET_KPI_LIST_FILTER_PARAMS = 'SET_KPI_LIST_FILTER_PARAMS';
export const SET_TASK_GRAPH_FILTER_PARAMS = 'SET_TASK_GRAPH_FILTER_PARAMS';
export const RESET_ALL_FILTERS = 'RESET_ALL_FILTERS';

export const FILTERS_INIT_STATE = {
    leadFilter: {},
    logFilter: {},
    columnFilter: [],
    taskListFilter: {},
    taskListFilterParams: {},
    proposalListFilterParams: {},
    taskGraphsFilterParams: {
        from: moment(),
        to: moment()
    },
};
